import { useState, useEffect } from 'react';

export const useCourses = () => {
    const [courses, setCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadCourses = () => {
            try {
                const savedCourses = localStorage.getItem("courses");
                if (savedCourses) {
                    const parsedCourses = JSON.parse(savedCourses);
                    setCourses(parsedCourses);
                }
            } catch (error) {
                console.error('Error loading courses:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadCourses();
    }, []);

    const addCourses = (newCourses) => {
        setCourses(newCourses);
        localStorage.setItem("courses", JSON.stringify(newCourses));
    };

    const updateCourse = (courseIndex, updatedCourse) => {
        const updatedCourses = [...courses];
        updatedCourses[courseIndex] = updatedCourse;
        setCourses(updatedCourses);
        localStorage.setItem("courses", JSON.stringify(updatedCourses));
    };

    const deleteCourse = (courseIndex) => {
        const updatedCourses = courses.filter((_, index) => index !== courseIndex);
        setCourses(updatedCourses);
        localStorage.setItem("courses", JSON.stringify(updatedCourses));
    };

    const clearCourses = () => {
        setCourses([]);
        localStorage.removeItem("courses");
    };

    return {
        courses,
        isLoading,
        addCourses,
        updateCourse,
        deleteCourse,
        clearCourses
    };
}; 